import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { ConfigService } from "../../../../services/configService";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { SearchResponse } from "../../../../objects/responses/searchResponse";
import { Customer } from "../../../../objects/customers/customer";
import { LocationCardComponent } from "../location-card/location-card.component";
import { Location } from "../../../../objects/management/locationManagement/location";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { NgForm, NgModel } from "@angular/forms";
import { FormHelper } from "../../../../common/helpers/formHelper";
import { ExtraData } from "../../../../objects/extraData/extraData";
import { ExtraDataService } from "../../../../services/extraDataService";
import { Select2Util } from "../../../../common/utils/select2Util";
import { ReferenceType } from "../../../../objects/extraData/extraDataSearchRequest";
import { OrderItem } from "../../../../objects/orders/orderItem";
import { ProductsCardComponent } from "../products-card/products-card.component";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
import { Guid } from "../../../../common/helpers/guidHelper";
import { ActivatedRoute, Router } from "@angular/router";
import { CalculatorService } from "../../../../services/calculator/calculatorService";
import { BaseExtraData } from "../../../extraData/baseExtraData";
import { CustomerService } from "../../../../services/customerService";
import { Subscribable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { OrderLocation } from "../../../../objects/management/order/orderLocation";
import { TaxType } from "../../../../objects/orders/taxType";
import { OrderBy } from "ngx-odata-v4";

/**
 * Created by vlad.p on 9/8/2017.
 */

declare var $: any;

@Component({
    selector: "customer-card",
    templateUrl: "customer-card.component.html",
    moduleId: module.id.toString()
})
export class CustomerCardComponent extends BaseExtraData implements AfterViewInit, OnDestroy {

    @Input()
    public order: Order;

    @Input()
    public locationCard: LocationCardComponent;

    @Input()
    public extraData: ExtraData;

    @Input()
    public disableChanges: boolean;

    @Input()
    public productsCard: ProductsCardComponent;

    @ViewChild('customerForm')
    private customerForm: NgForm;

    @ViewChild('lastNameModel')
    private lastNameModel: NgModel;

    @ViewChild('firstNameModel')
    private firstNameModel: NgModel;

    @Input()
    public isPublic: boolean = false;

    @Input()
    public isOrderDetails: boolean = false;

    @Output()
    public extraDataChange: EventEmitter<ExtraData> = new EventEmitter();

    public select2Util = Select2Util;
    public calculatorHelper = CalculatorHelper;

    public showForm: boolean = true;

    public select2EmailData: any = null;

    public hasExtraData: boolean = false;

    private formSubscribtion: Subscription;

    private emailSelected: boolean = false;

    @Input()
    public sendCustomer: boolean;

    get continuousBondFile(){
        return this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.ContinuousBondOnFile);
    }

    set continuousBondFile(val: boolean){
        if (val) {
            this.order.Flag |= OrderOptions.ContinuousBondOnFile;
        } else {
            this.order.Flag &= ~OrderOptions.ContinuousBondOnFile;
        }
    }

    constructor(public configService: ConfigService, public extraDataService: ExtraDataService,
                public router: Router, public calculatorService: CalculatorService,
                public customerService: CustomerService) {
        super(extraDataService);
    }

    public ngAfterViewInit(): void {
        this.initSelect2();
        this.handleFormChange();

        if (!String.isNullOrEmpty(this.extraData.Data))
            this.hasExtraData = true;
    }

    public ngOnDestroy() {
        this.formSubscribtion.unsubscribe();
    }

    private initSelect2(): void {
        if (this.isPublic)
            return;

        let self = this;

        let $emailSelect: any = $('#emailSelect');

        $emailSelect.select2({
            width: '100%',
            data: "",
            allowClear: true,
            placeholder: '',
            selectOnClose: false,
            ajax: {
                url: this.configService.config.ApiUrl + "/customer/search",
                datatype: 'json',
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + Cookie.get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params: any) {
                    return {
                        query: params.term,
                        fillOrders: true,
                        orderBy: '_score',
                        orderByDir: OrderBy.Desc.toString(),
                        skip: 0,
                        top: 10
                    };
                },
                processResults: function (response: BaseResponse<SearchResponse<Customer>>, params: any): any {
                    if (!response || !response.Data)
                        return [];

                    let results: any[] = response.Data.Items.map(function (customer) {
                        return {
                            id: customer.Id,
                            text: customer.Email,
                            Item: customer
                        }
                    });

                    if (results.length == 0)
                        results.push({ id: params.term, text: params.term });

                    self.emailSelected = false;

                    return {
                        results: results
                    };
                }
            },
            minimumInputLength: 2
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            if (!selectedData || !selectedData[0])
                return;

            self.emailSelected = true;
            if (selectedData[0].Item == null) {
                self.order.Customer.Email = selectedData[0].text.trim();
                return;
            }

            self.getExtraData(selectedData[0].id, ReferenceType.Order).then(x => {
                if (!x)
                    self.extraData = new ExtraData();
                else
                    self.extraData = x;

                if (!String.isNullOrEmpty(self.extraData.Data))
                    self.hasExtraData = true;

                self.extraDataChange.emit(self.extraData);
            });


            self.order.Customer.Email = selectedData[0].text.trim();

            self.prefillCustomerInfo(JSON.parse(JSON.stringify(selectedData[0].Item)), self.order.Customer);

            self.select2EmailData.trigger("select", { data: { item: selectedData[0].Item, text: selectedData[0].text, id: Guid.newGuid() } });
        }).on('select2:unselect', function (e: any) {
            self.order.Customer.Email = "";
            self.extraData = new ExtraData();
            self.hasExtraData = false;
            setTimeout(() => {
                self.emailSelected = false;
            });
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        }).on('select2:close', function (params: any) {
            setTimeout(() => {
                if (self.emailSelected)
                    return;

                let select = $(this).data("select2");
                let query = select.results.lastParams.term;

                if(!String.isNullOrEmpty(query)) {
                    self.emailSelected = true;
                    self.select2EmailData.trigger("select", {data: {item: null, text: query, id: Guid.newGuid()}});
                }
            });
        });

        this.select2EmailData = $emailSelect.data("select2");

        if (this.order.Customer && this.order.Customer.Email)
            this.select2EmailData.trigger("select", { data: { item: this.order.Customer, text: this.order.Customer.Email, id: Guid.newGuid() } });

        if (this.disableChanges)
            $emailSelect.prop("disabled", true);
    }

    private prefillCustomerInfo(customerFrom: Customer, customer: Customer): void {
        customer.Id = customerFrom.Id;
        customer.FirstName = customerFrom.FirstName;
        customer.LastName = customerFrom.LastName;
        customer.Company.Name = customerFrom.Company.Name;
        customer.Phone = customerFrom.Phone;
        customer.IsSeller = customerFrom.IsSeller;

        if (!customer.Location || !customer.Location.Country) {
            customer.Location = customerFrom.Location;
            customer.Location.Id = null; // need to null this, because when order is exists and we change customer(with existing location) this will override prev order location
            this.locationCard.setLocationFrom(customerFrom.Location);
        }

        //change extraData only if it's empty
        if (!this.extraData) {
            this.getExtraData(this.order.Customer.Id.toString(), ReferenceType.Order).then(x => {
                this.extraData = x;

                if (!String.isNullOrEmpty(this.extraData.Data))
                    this.hasExtraData = true;
            });


        }

        this.fillOrder(customerFrom, this.order);
    }

    private fillOrder(customerFrom: Customer, order: Order): void {
        if (customerFrom.Orders == null || customerFrom.Orders.length == 0)
            return;

        let latestCustomerOrder: Order = customerFrom.Orders.sort((a: any, b: any) => {
            return a.Created - b.Created
        })[0];

        if (latestCustomerOrder == null)
            return;

        order.Status = OrderStatus.Calculated;
        order.IsCommercial = latestCustomerOrder.IsCommercial;

        let loc: OrderLocation = order.Locations.find(x => x.Type == 2);

        let broadcastLocation: boolean = false;

        if (!loc || !loc.Country) {
            let shipmentTo: OrderLocation = latestCustomerOrder.Locations.find(x => x.Type == 2);

            if (shipmentTo != null) {
                order.Locations = new Array<OrderLocation>();
                order.Locations.push(shipmentTo);
                order.CalculatorType = CalculatorHelper.getCalculatorType([shipmentTo]);
            }

            this.locationCard.setLocationTo(shipmentTo);
        }
        else {
            broadcastLocation = true;
        }

        if (!this.isOrderEmpty(order))
            return;

        order.Flag = latestCustomerOrder.Flag;

        //TODO
        //this.productsCard.isQuickQuote = latestCustomerOrder.Flag.hasFlag(OrderOptions.IsQuickQuote);

        order.OrderItems = [];

        order.CarryingType = latestCustomerOrder.CarryingType;

        this.productsCard.isOneTime = latestCustomerOrder.Flag.hasFlag(OrderOptions.IsOneTime);

        if (order.Flag.hasFlag(OrderOptions.IsPulic))
            this.order.Flag &= ~OrderOptions.IsPulic;

        if (order.Flag.hasFlag(OrderOptions.IsBBFeeEdited))
            this.order.Flag &= ~OrderOptions.IsBBFeeEdited;

        for (let orderItem of latestCustomerOrder.OrderItems) {
            orderItem.Id = null;
            orderItem.OrderId = null;

            const aaTax = orderItem.Taxes.find(x => x.TaxType == TaxType.AAFee);

            if (aaTax != null)
                orderItem.Taxes.splice(orderItem.Taxes.indexOf(aaTax),1);

            for (let tax of orderItem.Taxes) {
                tax.Id = null;
                tax.ItemId = null;
            }

            order.OrderItems.push(orderItem);
        }

        if (order.OrderItems.length == 0)
            order.OrderItems.push(new OrderItem());

        this.locationCard.showCarryingTypes(order);

        if (broadcastLocation)
            setTimeout(() => {
                this.calculatorService.broadcast(loc);
            }, 300);
    }

    private isOrderEmpty(order: Order): boolean {
        if (this.order.OrderItems.length > 1)
            return false;

        for (let item of order.OrderItems) {
            if (item.Id || item.Manufacturer.Code || (item.Product && item.Product.Name) || item.Product.HsCode || item.Price || item.Type > 0 ||
                (CalculatorHelper.isVehicle(this.order) && item.Year))
                return false;
        }

        return true;
    }

    public checkForm(): boolean {
        this.customerForm.onSubmit(null);
        return this.customerForm.valid;
    }

    public isValid(): boolean {
        if (!this.customerForm)
            return false;
        return this.customerForm.valid;
    }

    public resetForm(): void {
        this.customerForm.resetForm();
        this.hasExtraData = false;
        this.order.Customer = new Customer();

        $('#emailSelect').val('').trigger("change");

        this.showForm = false;

        setTimeout(() => {
            this.showForm = true;

            setTimeout(() => {
                this.initSelect2();
                this.handleFormChange();
            });
        });
    }

    private handleFormChange(): void {
        this.formSubscribtion = this.customerForm.valueChanges.debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(modelValue => {
                if (this.customerForm.valid && this.sendCustomer)
                    this.customerService.updateInPipeDrive(this.order.Customer);
            });
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/cards/customer-card/customer-card.component.ts